import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPatient, getPatientChecked } from '../../reducer/patientSlice';
import { getProfile } from '../../reducer/profileSlice';
import { Map as MapOL, View } from 'ol';
import TileLayer from 'ol/layer/Tile';
import ImageLayer from 'ol/layer/Image';
import XYZ from 'ol/source/XYZ';
import VectorSource from 'ol/source/Vector';
import VectorImageLayer from 'ol/layer/VectorImage';
import Style from 'ol/style/Style';
import Fill from 'ol/style/Fill';
import Icon from 'ol/style/Icon';
import Stroke from 'ol/style/Stroke';
import Text from 'ol/style/Text';
import GeoJSON from 'ol/format/GeoJSON';
import Feature from 'ol/Feature';
import Circle from 'ol/style/Circle';
import Cluster from 'ol/source/Cluster';
import ImageWMS from 'ol/source/ImageWMS';
import Point from 'ol/geom/Point';
import { fromLonLat } from 'ol/proj';
import { defaults as defaultControls } from 'ol/control';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import DownloadIcon from '@mui/icons-material/Download';
import { getMorbidityChecked, getMorbidityRate } from '../../reducer/morbidityRateSlice';
import { getCompareChecked, getCompareValue } from '../../reducer/patientCompareSlice';
import { getCluster, getClusterChecked } from '../../reducer/clusterSlice';
import { getSpotmap, getSpotmapChecked } from '../../reducer/spotmapSlice';
import { getRenderType } from '../../reducer/renderTypeSlice';
import { getCOChecked, getCOValue, getNCOChecked, getNCOValue } from '../../reducer/LarvaIndexSlice';
import { getMapDataSelected, setMapDataSelected } from '../../reducer/mapDataSelectedSlice';
import { Button, Card, CardContent, CardHeader, Divider, FormControlLabel, FormGroup, IconButton, Switch, Typography } from '@mui/material';
import MorbidityLegend from './legends/MorbidityLegend';
import CompareLegend from './legends/CompareLegend';
import PatientLegend from './legends/PatientLegend';
import SpotmapLegend from './legends/SpotmapLegend';
import ClusterLegend from './legends/ClusterLegend';
import HILegend from './legends/HILegend';
import CILegend from './legends/CILegend';
import { getAreaSelected } from '../../reducer/areaSelectedSlice';
import { getD506UpdateTime } from '../../reducer/updateTimeSlice';
import dayjs from 'dayjs';
import { getAreaLevel } from '../../reducer/areaLevelSlice';
import { getMapSettingAreaName, getMapSettingAreaOnly, getMapSettingHighlight, setMapSettingAreaName, setMapSettingAreaOnly, setMapSettingHighlight } from '../../reducer/mapSettingSlice';

let layers = {}
let oldStyle;
let featureSelected;
const dataTypeShowDataList = ['morbidity', "compare", "patient", "spotmap", "cluster", "hi", "ci", "index"]

// const key = 'VI4aypb1ox7NMOXaJhj2';
// const url = 'https://api.maptiler.com/maps/basic-4326/style.json?key=' + key;
// const url = `https://api.maptiler.com/maps/630b398b-2d89-49f2-b66c-48c716b5a258/style.json?key=${key}`

// const exportOptions = {
//     useCORS: true,
//     allowTaint: true,
//     // ignoreElements: function (element) {
//     //     const className = element.className || '';
//     //     return (
//     //         className.includes('ol-control') &&
//     //         !className.includes('ol-scale') &&
//     //         (!className.includes('ol-attribution') ||
//     //             !className.includes('ol-uncollapsible'))
//     //     );
//     // },
// };

function Map() {
    const dispatch = useDispatch();
    const mapSettingAreaName = useSelector(getMapSettingAreaName);
    const mapSettingHighlight = useSelector(getMapSettingHighlight);
    const mapSettingAreaOnly = useSelector(getMapSettingAreaOnly);
    const areaLevel = useSelector(getAreaLevel);
    const morbidityChecked = useSelector(getMorbidityChecked);
    const compareChecked = useSelector(getCompareChecked);
    const patientChecked = useSelector(getPatientChecked);
    const spotmapChecked = useSelector(getSpotmapChecked);
    const clusterChecked = useSelector(getClusterChecked);
    const hiChecked = useSelector(getCOChecked);
    const ciChecked = useSelector(getNCOChecked);
    const morbidityValue = useSelector(getMorbidityRate);
    const compareValue = useSelector(getCompareValue);
    const patient = useSelector(getPatient);
    const clusters = useSelector(getCluster);
    const spotmap = useSelector(getSpotmap);
    const coValue = useSelector(getCOValue);
    const ncoValue = useSelector(getNCOValue);
    const renderType = useSelector(getRenderType);
    const profile = useSelector(getProfile);
    const d506UpdateTime = useSelector(getD506UpdateTime);
    const [labelShow, setLabelShow] = useState([]);
    const [openLegend, setOpenLegend] = useState(false);
    const [openSetting, setOpenSetting] = useState(false);
    // const [showDataOnlyArea, setShowDataOnlyArea] = useState(true);
    const areaSelected = useSelector(getAreaSelected);
    const mapDataSelected = useSelector(getMapDataSelected);

    const [map, setMap] = useState();
    const mapRef = useRef();
    const downloadRef = useRef();

    const getWMS = (layerName, index, filter) => {
        let params = {
            'QUERY_LAYERS': 'tanrabad:' + layerName,
            'LAYERS': 'tanrabad:' + layerName,
            '%20palette': 'safe'
        }
        if (filter) {
            params.cql_filter = filter;
        }
        let layer = new ImageLayer({
            source: new ImageWMS({
                url: 'https://trb-platform.ddc.moph.go.th/geoserver/tanrabad/wms',
                params: params,
                serverType: 'geoserver',
                crossOrigin: 'anonymous'
            }),
        });

        map.addLayer(layer);
        layer.setZIndex(index);
        layer.setVisible(mapSettingHighlight);
        return layer;
    }

    useEffect(() => {
        // console.log(mapDataSelected);
        if (Object.keys(mapDataSelected).length !== 0) {
            featureSelected = mapDataSelected;
            oldStyle = mapDataSelected.getStyle();
            let dataType = mapDataSelected.values_.datatype;
            let highlightStyle;
            if (dataType === "morbidity" || dataType === "compare") {
                let fillColor = mapDataSelected.getStyle().getFill().color_;
                let strokeStyle = mapDataSelected.getStyle().getStroke();
                highlightStyle = new Style({
                    fill: new Fill({
                        color: fillColor.substr(0, 7)
                    }),
                    stroke: new Stroke({
                        color: strokeStyle.color_,
                        width: 5
                    })
                });
            } else if (dataType === "patient") {
                let radius = mapDataSelected.getStyle().getImage().radius_;
                let zIndex = mapDataSelected.getStyle().zIndex_;
                highlightStyle = new Style({
                    image: new Circle({
                        radius: radius,
                        fill: new Fill({
                            color: "#3399CC"
                        }),
                        stroke: new Stroke({
                            color: "gray",
                            width: 3
                        })
                    }),
                    zIndex: zIndex
                });
            }
            mapDataSelected.setStyle(highlightStyle);
        } else {
            if (oldStyle !== undefined && featureSelected !== undefined) {
                featureSelected.setStyle(oldStyle);
            }
        }
    }, [mapDataSelected])

    const removeDataOnMap = (type) => {
        if (layers[type] !== undefined) {
            if (layers[type].length === undefined) {
                map.getLayers().remove(layers[type]);
                delete layers[type];
            } else {
                for (let index = 0; index < layers[type].length; index++) {
                    map.getLayers().remove(layers[type][index]);
                }
                delete layers[type];
            }
        }
    }

    const createPatientArea = (dataType, data) => {
        let feature;
        let style = new Style({
            fill: new Fill({
                color: `${data.color}AA`
            }),
            stroke: new Stroke({
                color: '#000000',
                width: 0.5
            }),
        });
        let f = new GeoJSON({
            dataProjection: 'EPSG:4326',
        });
        let geom = f.readGeometry(data.location);
        let attributesData = { ...data };
        delete attributesData["location"];

        feature = new Feature({
            geometry: geom,
            attributes: attributesData,
            datatype: dataType,
            name: data.name,
            id: data.code
        });
        feature.setStyle(style);
        return feature;
    }

    const checkInArea = (element) => {
        let inArea = false;
        if (mapSettingAreaOnly) {
            if (areaSelected.level === 1) {
                inArea = true;
            } else if (areaSelected.level === 2) {
                if (areaSelected.prov_list.indexOf(element.province_code) !== -1) {
                    inArea = true;
                }
            } else if (areaSelected.level === 3) {
                if (areaSelected.value === element.province_code) {
                    inArea = true;
                }
            } else if (areaSelected.level === 4) {
                if (element.amphur_code !== undefined) {
                    if (areaSelected.value === element.amphur_code) {
                        inArea = true;
                    }
                } else {
                    const prov_code = areaSelected.value.substr(0, 2);
                    if (prov_code === element.province_code) {
                        inArea = true;
                    }
                }
            } else {
                if (element.tambon_code !== undefined) {
                    if (areaSelected.value === element.tambon_code) {
                        inArea = true;
                    }
                } else {
                    if (element.amphur_code !== undefined) {
                        const amp_code = areaSelected.value.substr(0, 4);
                        if (amp_code === element.amphur_code) {
                            inArea = true;
                        }
                    } else {
                        const prov_code = areaSelected.value.substr(0, 2);
                        if (prov_code === element.province_code) {
                            inArea = true;
                        }
                    }
                }
            }
        } else {
            inArea = true;
        }
        return inArea;
    }

    useEffect(() => {
        // console.log(areaSelected);
        if (map !== undefined) {
            let hasMorbidity = Object.keys(morbidityValue).length !== 0;
            let hasCompare = Object.keys(compareValue).length !== 0;
            if (hasMorbidity || hasCompare) {
                let areaType = 'morbidity';
                let listData = [];
                if (hasCompare) {
                    areaType = 'compare'
                    listData = [...Object.values(compareValue)];
                } else {
                    listData = [...Object.values(morbidityValue)]
                }
                if (layers["morbidity"]) {
                    removeDataOnMap("morbidity");
                } else {
                    removeDataOnMap("compare");
                }
                let vectorSource = new VectorSource();
                // console.log(listData);
                for (let index = 0; index < listData.length; index++) {
                    const element = listData[index];
                    let inArea = checkInArea(element);
                    // let inArea = false;
                    // if (mapSettingAreaOnly) {
                    //     if (areaSelected.level === 1) {
                    //         inArea = true;
                    //     } else if (areaSelected.level === 2) {
                    //         if (areaSelected.prov_list.indexOf(element.province_code) !== -1) {
                    //             inArea = true;
                    //         }
                    //     } else if (areaSelected.level === 3) {
                    //         if (areaSelected.value === element.province_code) {
                    //             inArea = true;
                    //         }
                    //     } else if (areaSelected.level === 4 ) {
                    //         if (element.amphur_code !== undefined) {
                    //             if (areaSelected.value === element.amphur_code) {
                    //                 inArea = true;
                    //             }
                    //         } else {
                    //             const prov_code = areaSelected.value.substr(0, 2);
                    //             if (prov_code === element.province_code) {
                    //                 inArea = true;
                    //             }
                    //         }
                    //     } else {
                    //         if (element.tambon_code !== undefined) {
                    //             if (areaSelected.value === element.tambon_code) {
                    //                 inArea = true;
                    //             }
                    //         } else {
                    //             if (element.amphur_code !== undefined) {
                    //                 const amp_code = areaSelected.value.substr(0, 4);
                    //                 if (amp_code === element.amphur_code) {
                    //                     inArea = true;
                    //                 }
                    //             } else {
                    //                 const prov_code = areaSelected.value.substr(0, 2);
                    //                 if (prov_code === element.province_code) {
                    //                     inArea = true;
                    //                 }
                    //             }
                    //         }
                    //     }
                    // } else {
                    //     inArea = true;
                    // }

                    if (inArea) {
                        let feature = createPatientArea(areaType, element);
                        vectorSource.addFeature(feature);
                    }
                }
                let vectorLayer = new VectorImageLayer({
                    source: vectorSource
                })
                map.addLayer(vectorLayer);
                vectorLayer.setZIndex(2);

                layers[areaType] = vectorLayer;
            } else {
                if (layers["morbidity"]) {
                    removeDataOnMap("morbidity");
                } else {
                    removeDataOnMap("compare");
                }
            }
        }
    }, [morbidityValue, compareValue, areaSelected, mapSettingAreaOnly, map]);

    const renderClusterAllPoint = () => {
        let listData = [...Object.values(clusters)];
        let vectorSource = new VectorSource();
        // console.log(listData);
        for (let index = 0; index < listData.length; index++) {
            const listCluster = listData[index];
            for (let index = 0; index < listCluster.length; index++) {
                const element = listCluster[index];
                const inArea = checkInArea(element);
                if (inArea) {
                    let style = new Style({
                        image: new Circle({
                            radius: element.size,
                            stroke: new Stroke({
                                color: "#009dff",
                                width: 3
                            }),
                            fill: new Fill({
                                color: "rgba(0, 0, 0, 0)",
                            }),
                        }),
                        zIndex: element.zIndex
                    });
                    let f = new GeoJSON({
                        dataProjection: 'EPSG:4326'
                    });
                    let geom = f.readGeometry(element.location);
                    let feature = new Feature({
                        geometry: geom,
                        attributes: element,
                        datatype: "cluster",
                    });
                    feature.setStyle(style);
                    vectorSource.addFeature(feature);
                }
            }
        }
        let vectorLayer = new VectorImageLayer({
            source: vectorSource
        })
        map.addLayer(vectorLayer);
        vectorLayer.setZIndex(90);

        layers["cluster"] = vectorLayer;
    }

    const renderClusterGroup = () => {
        let clusterList = [];
        let listData = [...Object.values(clusters)];
        for (let index = 0; index < listData.length; index++) {
            const listCluster = listData[index];
            for (let index = 0; index < listCluster.length; index++) {
                const element = listCluster[index];
                if (element.location) {
                    const inArea = checkInArea(element);
                    if (inArea) {
                        let vectorSource = clusterList["size_" + element.size];
                        if (vectorSource === undefined) {
                            vectorSource = new VectorSource();
                        }
                        let f = new GeoJSON({
                            dataProjection: 'EPSG:4326'
                        });
                        let geom = f.readGeometry(element.location);
                        let feature = new Feature({
                            geometry: geom,
                            attributes: element,
                            datatype: "cluster",
                            name: element.name,
                            id: element.code
                        });
                        vectorSource.addFeature(feature);
                        clusterList["size_" + element.size] = vectorSource;
                    }
                }
            }
        }

        let clustersGroup = [];
        for (const key in clusterList) {
            if (clusterList.hasOwnProperty(key)) {
                let vectorSource = clusterList[key];
                let clusterSource = new Cluster({
                    distance: 50,
                    source: vectorSource
                });
                let zIndex = vectorSource.getFeatures()[0].values_.attributes.zIndex;
                let clusters = new VectorImageLayer({
                    source: clusterSource,
                    style: function (feature) {
                        let size = feature.get('features').length;
                        let sizePoint = feature.get('features')[0].values_.attributes.size;
                        let zIndex = feature.get('features')[0].values_.attributes.zIndex;
                        let color = "#009dff";
                        let style;
                        if (size === 1) {
                            style = new Style({
                                image: new Circle({
                                    radius: sizePoint,
                                    stroke: new Stroke({
                                        color: color,
                                        width: 3
                                    }),
                                    fill: new Fill({
                                        color: "rgba(0, 0, 0, 0)",
                                    }),
                                }),
                                zIndex: zIndex
                            });
                        } else {
                            style = new Style({
                                image: new Circle({
                                    radius: sizePoint,
                                    stroke: new Stroke({
                                        color: color,
                                        width: 3
                                    }),
                                    fill: new Fill({
                                        color: "rgba(0, 0, 0, 0)",
                                    }),
                                }),
                                text: new Text({
                                    text: size.toString(),
                                    font: '10px Noto Sans Thai',
                                    fill: new Fill({
                                        color: '#000'
                                    })
                                }),
                                zIndex: zIndex + size
                            });
                        }
                        return style;
                    },
                });

                map.addLayer(clusters);
                clusters.setZIndex(zIndex);
                clustersGroup.push(clusters);
            }
        }

        layers["cluster"] = clustersGroup;

        // let newLayers = {
        //     ...layers,
        // }
        // newLayers["cluster"] = clustersGroup;
        // setLayers(newLayers);

        // this.overlay["cluster"] = clustersGroup;
    }

    useEffect(() => {
        if (map !== undefined) {
            if (layers["cluster"]) {
                removeDataOnMap("cluster");
            }
            if (Object.keys(clusters).length !== 0) {
                if (renderType === "all") {
                    renderClusterAllPoint();
                } else {
                    renderClusterGroup();
                }
            }
        }
    }, [clusters, renderType, areaSelected, mapSettingAreaOnly, map])

    const getStyle = (styles, data) => {
        var style;
        if (styles[data.color]) {
            style = styles[data.color];
        } else {
            style = new Circle({
                radius: 2,
                fill: new Fill({
                    color: data.color
                }),
                stroke: new Stroke({
                    color: data.color,
                    width: 1
                })
            })
            styles[data.color] = style;
        }
        return style;
    }

    const renderSpotMapAllPoint = () => {
        let listData = [...Object.values(spotmap)];
        var vectorSource = new VectorSource();
        var stylePointList = [];
        for (let index = 0; index < listData.length; index++) {
            const listPatient = listData[index];
            for (let index = 0; index < listPatient.length; index++) {
                const element = listPatient[index];
                const inArea = checkInArea(element);
                if (inArea) {
                    let stylePoint = getStyle(stylePointList, element);
                    let iconStyle = new Style({
                        image: stylePoint,
                        zIndex: 40
                    });
                    let f = new GeoJSON({
                        dataProjection: 'EPSG:4326'
                    });
                    let geom = f.readGeometry(element.location);
                    let feature = new Feature({
                        geometry: geom,
                        attributes: element,
                        datatype: "spotmap",
                    });
                    feature.setStyle(iconStyle);
                    vectorSource.addFeature(feature);   
                }
            }
        }
        let vectorLayer = new VectorImageLayer({
            source: vectorSource
        })
        map.addLayer(vectorLayer);
        vectorLayer.setZIndex(90);

        layers["spotmap"] = vectorLayer
        // let newLayers = {
        //     ...layers,
        // }
        // newLayers["spotmap"] = vectorLayer;
        // setLayers(newLayers);
    }

    const renderSpotMapCluster = () => {
        let listData = [...Object.values(spotmap)];
        let spotMapList = [];
        // let stylePointList = [];
        for (let index = 0; index < listData.length; index++) {
            const listPatient = listData[index];
            for (let index = 0; index < listPatient.length; index++) {
                const element = listPatient[index];
                if (element.location) {
                    const inArea = checkInArea(element);
                    if (inArea) {
                        let vectorSource = spotMapList[element.color];
                        if (vectorSource === undefined) {
                            vectorSource = new VectorSource();
                        }
                        let f = new GeoJSON({
                            dataProjection: 'EPSG:4326'
                        });
                        let geom = f.readGeometry(element.location);
                        let feature = new Feature({
                            geometry: geom,
                            attributes: element,
                            datatype: "spotmap",
                        });
                        vectorSource.addFeature(feature);
                        spotMapList[element.color] = vectorSource;
                    }
                }
            }
        }
        let spotMapGroup = [];
        for (const key in spotMapList) {
            if (spotMapList.hasOwnProperty(key)) {
                let vectorSource = spotMapList[key];
                let clusterSource = new Cluster({
                    distance: 50,
                    source: vectorSource,
                    datatype: "spotmap"
                });
                // let zIndex = vectorSource.getFeatures()[0].values_.attributes.zIndex;
                let clusters = new VectorImageLayer({
                    source: clusterSource,
                    style: function (feature) {
                        let size = feature.get('features').length;
                        // let zIndex = feature.get('features')[0].values_.attributes.zIndex;
                        let color = feature.get('features')[0].values_.attributes.color;
                        let style;
                        if (size === 1) {
                            style = new Style({
                                image: new Circle({
                                    radius: 2,
                                    fill: new Fill({
                                        color: color
                                    }),
                                    stroke: new Stroke({
                                        color: color,
                                        width: 1
                                    })
                                }),
                                zIndex: 90
                            });
                        } else {
                            style = new Style({
                                image: new Circle({
                                    radius: 13,
                                    fill: new Fill({
                                        color: color
                                    }),
                                    stroke: new Stroke({
                                        color: color,
                                        width: 1
                                    })
                                }),
                                text: new Text({
                                    text: size.toString(),
                                    font: '10px Noto Sans Thai',
                                    fill: new Fill({
                                        color: '#fff'
                                    })
                                }),
                                zIndex: 90 + size
                            });
                        }
                        return style;
                    },
                    // renderMode: 'image',
                });
                map.addLayer(clusters);
                clusters.setZIndex(90);
                spotMapGroup.push(clusters);
            }
        }
        layers["spotmap"] = spotMapGroup;
        // let newLayers = {
        //     ...layers,
        // }
        // newLayers["spotmap"] = spotMapGroup;
        // setLayers(newLayers);
    }

    useEffect(() => {
        if (map !== undefined) {
            if (layers["spotmap"]) {
                removeDataOnMap("spotmap");
            }
            if (Object.keys(spotmap).length !== 0) {
                if (renderType === 'all') {
                    renderSpotMapAllPoint();
                } else {
                    renderSpotMapCluster();
                }
            }
        }
    }, [spotmap, renderType, areaSelected, mapSettingAreaOnly, map])

    useEffect(() => {
        if (map !== undefined) {
            if (Object.keys(patient).length !== 0) {
                if (layers["patient"]) {
                    removeDataOnMap("patient");
                }
                let listData = [...Object.values(patient)];
                let vectorSource = new VectorSource();
                // console.log(listData);
                for (let index = 0; index < listData.length; index++) {
                    const element = listData[index];
                    const inArea = checkInArea(element);
                    if (inArea) {
                        let style = new Style({
                            image: new Circle({
                                radius: element.size,
                                fill: new Fill({
                                    color: "#D92405"
                                }),
                                stroke: new Stroke({
                                    color: "black",
                                    width: 1
                                })
                            }),
                            zIndex: 50 - (element.size / 3)
                        });
                        let f = new GeoJSON({
                            dataProjection: 'EPSG:4326',
                        });
                        let geom = f.readGeometry(element.location);
                        let attributesData = { ...element };
                        delete attributesData["location"];
                        let feature = new Feature({
                            geometry: geom,
                            attributes: attributesData,
                            datatype: "patient",
                            name: element.name,
                            id: element.code
                        });
                        feature.setStyle(style);
                        vectorSource.addFeature(feature);
                    }
                }

                let vectorLayer = new VectorImageLayer({
                    source: vectorSource
                })
                map.addLayer(vectorLayer);
                vectorLayer.setZIndex(50);

                layers['patient'] = vectorLayer;
            } else {
                if (layers["patient"]) {
                    removeDataOnMap("patient");
                }
            }
        }
    }, [patient, areaSelected, mapSettingAreaOnly,  map])

    useEffect(() => {
        if (profile !== undefined && profile !== null) {
            if (map === undefined) {
                const initialMap = new MapOL({
                    target: mapRef.current,
                    layers: [
                        new TileLayer({
                            source: new XYZ({
                                // url: `https://api.maptiler.com/maps/basic-v2/{z}/{x}/{y}.png?key=lH2JW9wBgx5zp3xfRC3J`,
                                // url: `https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}`
                                url: `http://tile.openstreetmap.org/{z}/{x}/{y}.png`,
                                crossOrigin: 'anonymous'
                            })
                        })
                    ],
                    view: new View({
                        projection: 'EPSG:4326',
                        center: [100.523186, 13.736717],
                        zoom: 10
                    }),
                    controls: defaultControls({
                        attribution: false
                    })
                })
                initialMap.on('click', function (evt) {
                    const pixel = evt.pixel;
                    let feature = initialMap.forEachFeatureAtPixel(pixel, function (feature) {
                        const featureType = feature.values_.datatype;
                        if (featureType !== undefined) {
                            const indexSearch = dataTypeShowDataList.indexOf(featureType);
                            if (indexSearch !== -1) {
                                return feature;
                            }
                        } else {
                            return feature;
                        }
                    });
                    if (feature) {
                        dispatch(setMapDataSelected(feature));
                    }
                });
                setMap(initialMap)
            }
        }
    }, [profile, dispatch, map])

    const renderHIDataAllPoint = () => {
        let vectorSource = new VectorSource();
        for (let index = 0; index < coValue.length; index++) {
            const element = coValue[index];
            let inArea = checkInArea(element);
            if (inArea) {
                let iconStyle = new Style({
                    image: new Icon(({
                        anchor: [0.5, 0.97],
                        anchorXUnits: 'fraction',
                        anchorYUnits: 'fraction',
                        src: "/images/markers/marker_" + element.imageSrc,
                        color: element.color,
                        scale: 0.08
                    })),
                    zIndex: element.zIndex
                });
                var feature = new Feature({
                    geometry: new Point(fromLonLat([element.longitude, element.latitude], 'EPSG:4326')),
                    attributes: element,
                    datatype: "index"
                });
                feature.setStyle(iconStyle);
                vectorSource.addFeature(feature);
            }
        }
        let vectorLayer = new VectorImageLayer({
            source: vectorSource
        });
        vectorLayer.setZIndex(99);
        map.addLayer(vectorLayer);
        layers["hi"] = vectorLayer;
    }

    const renderHIDataCluster = () => {
        let hiList = [];
        for (let index = 0; index < coValue.length; index++) {
            const element = coValue[index];
            if (element.longitude !== undefined && element.latitude !== undefined) {
                const inArea = checkInArea(element);
                if (inArea) {
                    if (hiList[element.color] === undefined) {
                        hiList[element.color] = new VectorSource();
                    }
                    var vectorSource = hiList[element.color];
                    let feature = new Feature({
                        geometry: new Point(fromLonLat([element.longitude, element.latitude], 'EPSG:4326')),
                        attributes: element,
                        datatype: "index"
                    });
                    vectorSource.addFeature(feature);
                    hiList[element.color] = vectorSource;
                }
            }
        }

        let clustersList = [];
        for (const key in hiList) {
            if (hiList.hasOwnProperty(key)) {
                let vectorSource = hiList[key];
                let clusterSource = new Cluster({
                    distance: 50,
                    source: vectorSource
                });
                let zIndex = vectorSource.getFeatures()[0].values_.attributes.zIndex;
                let clusters = new VectorImageLayer({
                    source: clusterSource,
                    style: function (feature) {
                        let size = feature.get('features').length;
                        let color = feature.get('features')[0].values_.attributes.color;
                        let style;
                        if (size === 1) {
                            let imageSrc = feature.get('features')[0].values_.attributes.imageSrc;
                            style = new Style({
                                image: new Icon(({
                                    anchor: [0.5, 0.97],
                                    anchorXUnits: 'fraction',
                                    anchorYUnits: 'fraction',
                                    src: "/images/markers/marker_" + imageSrc,
                                    color: color,
                                    scale: 0.08
                                })),
                                zIndex: 90
                            });
                        } else {
                            style = new Style({
                                image: new Icon(({
                                    anchor: [0.5, 0.97],
                                    anchorXUnits: 'fraction',
                                    anchorYUnits: 'fraction',
                                    src: "/images/markers/marker_empty.png",
                                    color: color,
                                    scale: 0.08
                                })),
                                text: new Text({
                                    text: size.toString(),
                                    font: '10px Noto Sans Thai',
                                    fill: new Fill({
                                        color: '#fff'
                                    }),
                                    offsetY: -25
                                }),
                                zIndex: 90 + size
                            });
                        }
                        return style;
                    }
                });
                map.addLayer(clusters);
                clusters.setZIndex(zIndex);
                clustersList.push(clusters);
            }
        }
        layers["hi"] = clustersList;
    }

    const renderCIDataAllPoint = () => {
        let vectorSource = new VectorSource({
            attributions: {
                layers: "ci"
            }
        });
        for (let index = 0; index < ncoValue.length; index++) {
            const element = ncoValue[index];
            const inArea = checkInArea(element);
            if (inArea) {
                let iconStyle = new Style({
                    image: new Icon(({
                        anchor: [0.5, 0.97],
                        anchorXUnits: 'fraction',
                        anchorYUnits: 'fraction',
                        src: "/images/markers/marker_" + element.imageSrc,
                        color: element.color,
                        scale: 0.08
                    })),
                    zIndex: element.zIndex
                });
                let feature = new Feature({
                    geometry: new Point(fromLonLat([element.longitude, element.latitude], 'EPSG:4326')),
                    attributes: element,
                    datatype: "index"
                });
                feature.setStyle(iconStyle);
                vectorSource.addFeature(feature);
            }
        }
        let vectorLayer = new VectorImageLayer({
            source: vectorSource
        });
        map.addLayer(vectorLayer);
        vectorLayer.setZIndex(199);
        layers["ci"] = vectorLayer;
    }

    const renderCIDataCluster = () => {
        let ciList = [];
        for (let index = 0; index < ncoValue.length; index++) {
            const element = ncoValue[index];
            if (element.longitude !== undefined && element.latitude !== null) {
                const inArea = checkInArea(element);
                if (inArea) {
                    if (ciList[element.color] === undefined) {
                        ciList[element.color] = new VectorSource();
                    }
                    let vectorSource = ciList[element.color];
                    let feature = new Feature({
                        geometry: new Point(fromLonLat([element.longitude, element.latitude], 'EPSG:4326')),
                        attributes: element,
                        datatype: "index"
                    });
                    vectorSource.addFeature(feature);
                    ciList[element.color] = vectorSource;
                }
            }
        }
        var clustersList = [];
        for (const key in ciList) {
            if (ciList.hasOwnProperty(key)) {
                var vectorSource = ciList[key];
                var clusterSource = new Cluster({
                    distance: 50,
                    source: vectorSource
                });
                var zIndex = vectorSource.getFeatures()[0].values_.attributes.zIndex;
                var clusters = new VectorImageLayer({
                    source: clusterSource,
                    style: function (feature) {
                        var size = feature.get('features').length;
                        var color = feature.get('features')[0].values_.attributes.color;
                        var style;
                        if (size === 1) {
                            var imageSrc = feature.get('features')[0].values_.attributes.imageSrc;
                            style = new Style({
                                image: new Icon(({
                                    anchor: [0.5, 0.97],
                                    anchorXUnits: 'fraction',
                                    anchorYUnits: 'fraction',
                                    src: "/images/markers/marker_" + imageSrc,
                                    color: color,
                                    scale: 0.08
                                })),
                                zIndex: 190
                            });
                        } else {
                            style = new Style({
                                image: new Icon(({
                                    anchor: [0.5, 0.97],
                                    anchorXUnits: 'fraction',
                                    anchorYUnits: 'fraction',
                                    src: "/images/markers/marker_empty.png",
                                    color: color,
                                    scale: 0.08
                                })),
                                text: new Text({
                                    text: size.toString(),
                                    font: '10px Noto Sans Thai',
                                    fill: new Fill({
                                        color: '#fff'
                                    }),
                                    offsetY: -25
                                }),
                                zIndex: 190 + size
                            });
                        }
                        return style;
                    }
                });
                map.addLayer(clusters);
                clusters.setZIndex(zIndex);
                clustersList.push(clusters);
            }
        }
        layers["ci"] = clustersList;
    }

    const renderIndexBoth = () => {
        var indexList = [];
        for (let index = 0; index < coValue.length; index++) {
            const element = coValue[index];
            if (element.latitude !== undefined && element.longitude !== undefined) {
                const inArea = checkInArea(element);
                if (inArea) {
                    if (indexList[element.color] === undefined) {
                        indexList[element.color] = new VectorSource();
                    }
                    let vectorSource = indexList[element.color];
                    let feature = new Feature({
                        geometry: new Point(fromLonLat([element.longitude, element.latitude], 'EPSG:4326')),
                        attributes: element,
                        datatype: "index"
                    });
                    vectorSource.addFeature(feature);
                    indexList[element.color] = vectorSource;
                }
            }
        }
        for (let index = 0; index < ncoValue.length; index++) {
            const element = ncoValue[index];
            if (element.latitude !== undefined && element.longitude !== undefined) {
                const inArea = checkInArea(element);
                if (inArea) {
                    if (indexList[element.color] === undefined) {
                        indexList[element.color] = new VectorSource();
                    }
                    let vectorSource = indexList[element.color];
                    let feature = new Feature({
                        geometry: new Point(fromLonLat([element.longitude, element.latitude], 'EPSG:4326')),
                        attributes: element,
                        datatype: "index"
                    });
                    vectorSource.addFeature(feature);
                    indexList[element.color] = vectorSource;
                }
            }
        }
        let clustersList = [];
        for (const key in indexList) {
            if (indexList.hasOwnProperty(key)) {
                let vectorSource = indexList[key];
                let zIndex = 190;
                if (key === "#41A30D") {
                    zIndex = 187;
                } else if (key === "#FFCE38") {
                    zIndex = 188;
                } else if (key === "#EF6A23") {
                    zIndex = 189;
                }
                var clusterSource = new Cluster({
                    distance: 50,
                    source: vectorSource
                });
                var clusters = new VectorImageLayer({
                    source: clusterSource,
                    style: function (feature) {
                        var size = feature.get('features').length;
                        var color = feature.get('features')[0].values_.attributes.color;
                        var style;
                        if (size === 1) {
                            var imageSrc = feature.get('features')[0].values_.attributes.imageSrc;
                            style = new Style({
                                image: new Icon(({
                                    anchor: [0.5, 0.97],
                                    anchorXUnits: 'fraction',
                                    anchorYUnits: 'fraction',
                                    src: "/images/markers/marker_" + imageSrc,
                                    color: color,
                                    scale: 0.08
                                })),
                                zIndex: 190
                            });
                        } else {
                            style = new Style({
                                image: new Icon(({
                                    anchor: [0.5, 0.97],
                                    anchorXUnits: 'fraction',
                                    anchorYUnits: 'fraction',
                                    src: "/images/markers/marker_empty.png",
                                    color: color,
                                    scale: 0.08
                                })),
                                text: new Text({
                                    text: size.toString(),
                                    font: '10px Noto Sans Thai',
                                    fill: new Fill({
                                        color: '#fff'
                                    }),
                                    offsetY: -25
                                }),
                                zIndex: 190 + size
                            });
                        }
                        return style;
                    },
                    // renderMode: 'image',
                });
                map.addLayer(clusters);
                clusters.setZIndex(zIndex);
                clustersList.push(clusters);
            }
        }
        layers["index"] = clustersList;
    }

    useEffect(() => {
        if (map !== undefined) {

            if (layers["hi"]) {
                removeDataOnMap("hi");
            }
            if (layers["ci"]) {
                removeDataOnMap("ci");
            }
            if (layers["index"]) {
                removeDataOnMap("index");
            }
            if (coValue.length !== 0 && ncoValue !== 0) {
                if (renderType === 'all') {
                    renderHIDataAllPoint();
                    renderCIDataAllPoint();
                } else {
                    renderIndexBoth();
                }
            } else {
                if (coValue.length !== 0) {
                    if (renderType === 'all') {
                        renderHIDataAllPoint();
                    } else {
                        renderHIDataCluster();
                    }
                } else {
                    if (renderType === 'all') {
                        renderCIDataAllPoint();
                    } else {
                        renderCIDataCluster();
                    }
                }
            }
        }
    }, [coValue, ncoValue, renderType, areaSelected, mapSettingAreaOnly, map])

    useEffect(() => {
        let tmp = [];
        if (morbidityChecked) {
            tmp.push(<MorbidityLegend />);
        }
        if (compareChecked) {
            tmp.push(<CompareLegend />);
        }
        if (patientChecked) {
            tmp.push(<PatientLegend />);
        }
        if (spotmapChecked) {
            tmp.push(<SpotmapLegend />);
        }
        if (clusterChecked) {
            tmp.push(<ClusterLegend />);
        }
        if (hiChecked) {
            tmp.push(<HILegend />);
        }
        if (ciChecked) {
            tmp.push(<CILegend />);
        }
        setLabelShow(tmp);
    }, [morbidityChecked, compareChecked, patientChecked, spotmapChecked, clusterChecked, hiChecked, ciChecked])

    useEffect(() => {
        if (map !== undefined) {
            if (layers["blur"]) {
                removeDataOnMap("blur");
            }
            if (areaSelected.level !== 1) {
                let layerBlur = "tambon_blur";
                let filter = `tambon_code<>${areaSelected.value}`;
                if (areaSelected.level === 2) {
                    layerBlur = "health_region_blur";
                    filter = `health_region_type_id = 4 AND health_region_code <> '${areaSelected.value}'`;
                } else if (areaSelected.level === 3) {
                    layerBlur = "province_blur";
                    filter = `prov_code <> '${areaSelected.value}'`;
                } else if (areaSelected.level === 4) {
                    layerBlur = "amphur_blur";
                    filter = `amp_code <> '${areaSelected.value}'`;
                }
                layers["blur"] = getWMS(layerBlur, 999, filter);
                layers["blur"].setVisible(mapSettingHighlight);
            }

            map.getView().fit(areaSelected.bbox, {
                size: map.getSize(),
                nearest: true
            })
        }
    }, [areaSelected, map])

    useEffect(() => {
        if (map !== undefined) {
            if (layers["area_name"]) {
                removeDataOnMap("area_name");
            }

            let layerBlur = "tambon_name";
            if (areaLevel === "province") {
                layerBlur = "province_name";
            } else if (areaLevel === "amphur") {
                layerBlur = "amphur_name";
            }
            layers["area_name"] = getWMS(layerBlur, 900, undefined);
            layers["area_name"].setVisible(mapSettingAreaName);
        }
    }, [areaLevel, map])

    useEffect(() => {
        if (layers["area_name"] !== undefined) {
            layers["area_name"].setVisible(mapSettingAreaName)
        }
    }, [mapSettingAreaName])

    useEffect(() => {
        if (layers["blur"] !== undefined) {
            layers["blur"].setVisible(mapSettingHighlight)
        }
    }, [mapSettingHighlight])

    const exportMap = () => {
        map.once('rendercomplete', async () => {
            const mapCanvas = document.createElement('canvas');
            const size = map.getSize();
            mapCanvas.width = size[0];
            mapCanvas.height = size[1];
            const mapContext = mapCanvas.getContext('2d');
            Array.prototype.forEach.call(
                document.querySelectorAll('.ol-layer canvas'),
                (canvas) => {
                    if (canvas.width > 0) {
                        const opacity = canvas.parentNode.style.opacity;
                        mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
                        const transform = canvas.style.transform;
                        // Get the transform parameters from the style's transform matrix
                        const matrix = transform
                            .match(/^matrix\(([^\(]*)\)$/)[1]
                            .split(',')
                            .map(Number);
                        // Apply the transform to the export map context
                        CanvasRenderingContext2D.prototype.setTransform.apply(
                            mapContext,
                            matrix,
                        );
                        mapContext.drawImage(canvas, 0, 0);
                    }
                },
            );
            mapContext.globalAlpha = 1;
            mapContext.setTransform(1, 0, 0, 1, 0, 0);
            const link = downloadRef.current;
            link.href = mapCanvas.toDataURL('image/jpeg');
            link.click();
        })
        map.renderSync();
    }

    return (
        <>
            <div ref={mapRef} style={{
                width: '100%',
                height: '100%',
                position: 'relative'
            }}>
                <Button
                    component="label"
                    // role={undefined}
                    variant="contained"
                    tabIndex={-1}
                    startIcon={<DownloadIcon />}
                    style={{
                        position: 'absolute',
                        zIndex: 10,
                        left: 40,
                        top: 10,
                        backgroundColor: 'white',
                        color: 'black'
                    }}
                    onClick={() => {
                        exportMap();
                    }}
                >
                    Download
                </Button>
                <Card sx={{
                    position: 'absolute',
                    right: 10,
                    top: 10,
                    backgroundColor: 'white',
                    zIndex: 10
                }}>
                    <CardContent sx={(theme) => ({
                        '&.MuiCardContent-root': {
                            paddingBottom: '10px',
                            paddingTop: '10px',
                            // maxHeight: '300px',
                            overflow: 'auto',
                        }
                    })}>
                        <Typography
                            sx={{
                                color: 'black',
                                fontSize: '1rem',
                                fontWeight: '400',
                            }}
                        >
                            อัพเดทข้อมูลวันที่ {dayjs(d506UpdateTime).format("DD MMMM BBBB")}
                        </Typography>
                    </CardContent>
                </Card>

                <Card sx={{
                    position: 'absolute',
                    right: 10,
                    bottom: 10,
                    backgroundColor: 'white',
                    zIndex: 10
                }}>
                    <CardHeader
                        title="ตั้งค่า"
                        action={
                            <IconButton
                                aria-label="ขยาย"
                                onClick={() => {
                                    setOpenSetting(!openSetting);
                                }}
                            >
                                {
                                    !openSetting ? <ExpandLessIcon /> : <ExpandMoreIcon />
                                }
                            </IconButton>
                        }
                        sx={(theme) => ({
                            '& .MuiCardHeader-title': {
                                fontSize: '14px',
                                textAlign: 'left',
                                fontWeight: '400',
                            },
                            '&.MuiCardHeader-root': {
                                paddingTop: '5px',
                                paddingBottom: '5px'
                            }
                        })}
                    />
                    {
                        openSetting ?
                            <>
                                <Divider />
                                <CardContent sx={(theme) => ({
                                    '&.MuiCardContent-root': {
                                        paddingBottom: '10px',
                                        paddingTop: '10px',
                                        maxHeight: '300px',
                                        overflow: 'auto',
                                    }
                                })}>
                                    <FormGroup>
                                        <FormControlLabel
                                            control={
                                                <Switch checked={mapSettingHighlight} onChange={(event) => {
                                                    dispatch(setMapSettingHighlight(event.target.checked))
                                                }} />
                                            }
                                            label="Highlight"
                                        />
                                        <FormControlLabel
                                            control={
                                                <Switch checked={mapSettingAreaName} onChange={(event) => {
                                                    dispatch(setMapSettingAreaName(event.target.checked))
                                                }} />
                                            }
                                            label="ชื่อพื้นที่"
                                        />
                                        <FormControlLabel
                                            control={
                                                <Switch checked={mapSettingAreaOnly} onChange={(event) => {
                                                    dispatch(setMapSettingAreaOnly(event.target.checked))
                                                }} />
                                            }
                                            label="แสดงเฉพาะพื้นที่รับผิดชอบ"
                                        />
                                    </FormGroup>
                                </CardContent>
                            </> : <></>
                    }
                </Card>


                <Card sx={{
                    position: 'absolute',
                    left: 10,
                    bottom: 10,
                    width: 250,
                    backgroundColor: 'white',
                    zIndex: 10
                }}>
                    <CardHeader
                        title="คำอธิบายสัญลักษณ์"
                        action={
                            <IconButton
                                aria-label="ขยาย"
                                onClick={() => {
                                    setOpenLegend(!openLegend);
                                }}
                            >
                                {
                                    !openLegend ? <ExpandLessIcon /> : <ExpandMoreIcon />
                                }
                            </IconButton>
                        }
                        sx={(theme) => ({
                            '& .MuiCardHeader-title': {
                                fontSize: '14px',
                                textAlign: 'left',
                                fontWeight: '400',
                            },
                            '&.MuiCardHeader-root': {
                                paddingTop: '5px',
                                paddingBottom: '5px'
                            }
                        })}
                    />
                    {
                        openLegend ?
                            <>
                                <Divider />
                                <CardContent sx={(theme) => ({
                                    '&.MuiCardContent-root': {
                                        paddingBottom: '10px',
                                        paddingTop: '10px',
                                        maxHeight: '300px',
                                        overflow: 'auto',
                                    }
                                })}>
                                    {
                                        labelShow.map((data, index) => {
                                            const showDivider = index + 1 !== labelShow.length;
                                            return (
                                                <div key={index}>
                                                    {data}
                                                    {
                                                        showDivider ? <Divider sx={{
                                                            marginTop: '10px',
                                                            marginBottom: '10px'
                                                        }} /> : <></>
                                                    }
                                                </div>
                                            )
                                        })
                                    }
                                </CardContent>
                            </> : <></>
                    }
                </Card>
            </div>
            <a ref={downloadRef} download="map.png"></a>
        </>
    )
}

export default Map
